import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import { Button, TextArea, IconButton } from '@/shared/components/ui';
import { FeatherAlertTriangle, FeatherX } from '@subframe/core';
interface CancelProcessModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (motivo: string, comentario?: string) => void;
  isSubmitting?: boolean;
  // Antes da triagem concluída = cancelamento direto; depois = solicitação à secretaria.
  modoDireto?: boolean;
}
const MOTIVOS_CANCELAMENTO = ['Acordo entre as partes', 'Desistência do requerente', 'Inadimplência das custas', 'Impedimento do árbitro', 'Erro no cadastro', 'Outros'];
export function CancelProcessModal(t0) {
  const $ = _c(52);
  const {
    isOpen,
    onClose,
    onConfirm,
    isSubmitting: t1,
    modoDireto: t2
  } = t0;
  const isSubmitting = t1 === undefined ? false : t1;
  const modoDireto = t2 === undefined ? true : t2;
  const [motivoSelecionado, setMotivoSelecionado] = useState("");
  const [comentario, setComentario] = useState("");
  const motivoObrigatorio = !modoDireto;
  const podeConfirmar = !motivoObrigatorio || motivoSelecionado.length > 0;
  let t3;
  if ($[0] !== comentario || $[1] !== motivoSelecionado || $[2] !== onConfirm || $[3] !== podeConfirmar) {
    t3 = () => {
      if (!podeConfirmar) {
        return;
      }
      onConfirm(motivoSelecionado, comentario);
    };
    $[0] = comentario;
    $[1] = motivoSelecionado;
    $[2] = onConfirm;
    $[3] = podeConfirmar;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleConfirm = t3;
  let t4;
  if ($[5] !== onClose) {
    t4 = () => {
      onClose();
      setTimeout(() => {
        setMotivoSelecionado("");
        setComentario("");
      }, 300);
    };
    $[5] = onClose;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleClose = t4;
  if (!isOpen) {
    return null;
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="bg-error-50 flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full"><FeatherAlertTriangle className="text-error-600 h-5 w-5" /></div>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = modoDireto ? "Cancelar processo" : "Solicitar cancelamento";
  let t7;
  if ($[8] !== t6) {
    t7 = <h2 className="text-heading-3 font-heading-3 text-default-font">{t6}</h2>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = modoDireto ? "Esta a\xE7\xE3o encerra o processo imediatamente." : "Seu pedido ser\xE1 enviado \xE0 secretaria para an\xE1lise.";
  let t9;
  if ($[10] !== t8) {
    t9 = <p className="text-body text-subtext-color">{t8}</p>;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t7 || $[13] !== t9) {
    t10 = <div className="flex items-center gap-4">{t5}<div className="flex flex-col gap-0.5">{t7}{t9}</div></div>;
    $[12] = t7;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <FeatherX />;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== handleClose) {
    t12 = <IconButton variant="neutral-tertiary" icon={t11} onClick={handleClose} />;
    $[16] = handleClose;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t10 || $[19] !== t12) {
    t13 = <div className="flex items-start justify-between border-b border-solid border-neutral-100 px-6 py-5">{t10}{t12}</div>;
    $[18] = t10;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== motivoObrigatorio) {
    t14 = <label className="text-body-bold font-body-bold text-default-font">Motivo do cancelamento{" "}{motivoObrigatorio ? <span className="text-error-500">*</span> : <span className="text-caption text-subtext-color font-normal">(opcional)</span>}</label>;
    $[21] = motivoObrigatorio;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== motivoSelecionado) {
    t15 = MOTIVOS_CANCELAMENTO.map(motivo => <label key={motivo} className={`flex cursor-pointer items-center gap-3 rounded-lg border border-solid p-3 transition-all ${motivoSelecionado === motivo ? "border-error-300 bg-error-50 ring-error-200 ring-1" : "border-neutral-200 bg-white hover:border-neutral-300 hover:bg-neutral-50"}`}><input type="radio" name="motivoCancelamento" value={motivo} checked={motivoSelecionado === motivo} onChange={e => setMotivoSelecionado(e.target.value)} className="text-error-600 focus:ring-error-500 h-4 w-4 border-neutral-300" /><span className="text-body text-default-font font-medium">{motivo}</span></label>);
    $[23] = motivoSelecionado;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t15) {
    t16 = <div className="flex flex-col gap-2">{t15}</div>;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t14 || $[28] !== t16) {
    t17 = <div className="flex flex-col gap-3">{t14}{t16}</div>;
    $[27] = t14;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <label className="text-body-bold font-body-bold text-default-font">Comentário adicional{" "}<span className="text-caption text-subtext-color font-normal">(opcional)</span></label>;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = e_0 => setComentario(e_0.target.value);
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== comentario) {
    t20 = <div className="flex flex-col gap-2">{t18}<TextArea><TextArea.Input placeholder="Descreva mais detalhes sobre o motivo do cancelamento..." value={comentario} onChange={t19} rows={3} /></TextArea></div>;
    $[32] = comentario;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== t17 || $[35] !== t20) {
    t21 = <div className="flex max-h-[70vh] flex-col gap-6 overflow-y-auto px-6 py-6">{t17}{t20}</div>;
    $[34] = t17;
    $[35] = t20;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== handleClose || $[38] !== isSubmitting) {
    t22 = <Button variant="neutral-secondary" onClick={handleClose} disabled={isSubmitting}>Voltar</Button>;
    $[37] = handleClose;
    $[38] = isSubmitting;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  const t23 = !podeConfirmar || isSubmitting;
  const t24 = modoDireto ? "Confirmar cancelamento" : "Enviar solicita\xE7\xE3o";
  let t25;
  if ($[40] !== handleConfirm || $[41] !== isSubmitting || $[42] !== t23 || $[43] !== t24) {
    t25 = <Button variant="destructive-primary" onClick={handleConfirm} disabled={t23} loading={isSubmitting}>{t24}</Button>;
    $[40] = handleConfirm;
    $[41] = isSubmitting;
    $[42] = t23;
    $[43] = t24;
    $[44] = t25;
  } else {
    t25 = $[44];
  }
  let t26;
  if ($[45] !== t22 || $[46] !== t25) {
    t26 = <div className="flex items-center justify-end gap-2 border-t border-solid border-neutral-100 bg-neutral-50 px-6 py-4">{t22}{t25}</div>;
    $[45] = t22;
    $[46] = t25;
    $[47] = t26;
  } else {
    t26 = $[47];
  }
  let t27;
  if ($[48] !== t13 || $[49] !== t21 || $[50] !== t26) {
    t27 = <div className="animate-in fade-in fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm duration-200"><div className="animate-in zoom-in-95 flex w-full max-w-[500px] flex-col overflow-hidden rounded-xl bg-white shadow-2xl duration-200">{t13}{t21}{t26}</div></div>;
    $[48] = t13;
    $[49] = t21;
    $[50] = t26;
    $[51] = t27;
  } else {
    t27 = $[51];
  }
  return t27;
}